import { render, staticRenderFns } from "./SectionMod.vue?vue&type=template&id=2fce97fe"
import script from "./SectionMod.vue?vue&type=script&lang=js"
export * from "./SectionMod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports